<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台发票收取规则</div>
    <div class="main_item">
      <p>
        第一条
        为推动传统工作方式的转变和非实物服务网络交易的繁荣，保障神州邦邦平台用户合法权益，维护神州邦邦平台正常经营秩序，根据国家相关法律法规及《神州邦邦平台服务协议》制定本规则。
      </p>
    </div>
    <div class="main_item">
      <p>
        第二条
        本规则适用于所有受神州邦邦平台指定主体授权企业类工程师，交易包括作品买卖，服务买卖等。
      </p>
    </div>
    <div class="main_item">
      <p>第三条 发票收取的场景</p>
      <p>神州邦邦平台授权并委托企业类工程师向雇主提供服务，在服务交易完成后，由企业类工程师向神州邦邦平台开具正规发票；神州邦邦平台向企业类工程师收取发票类型为：增值税专用发票。神州邦邦平台在收到并验证发票无误后，企业类工程师才能在神州邦邦个人中心订单提现内对相应的服务收款完成提现。</p>
    </div>
    <div class="main_item">
      <p>第四条 工程师发票开具时点、指引</p>
      <p>根据神州邦邦平台业务规则及本规则第三条所规定，工程师在完成神州邦邦平台授权并委托的订单，得到雇主验收并打款且质保期满30日后，在个人中心-订单提现-去提现-选择需提现的订单-发起提现，工作人员稍后会与您联系沟通开票事宜，神州邦邦收到您所开具的信息无误的发票后，提现申请方可通过。</p>
    </div>
    <div class="main_item">
      <p>第五条 发票信息规范要求</p>
      <p>发票抬头：北京神州邦邦技术服务有限公司（示例，请以订单记录为准）</p>
      <p>纳税人识别号：XXXXXXXXXXXXXXXXXX（示例，请以订单记录为准）</p>
      <p>注册地址：北京市延庆区中关村延庆园风谷四路8号院27号楼2024（示例，请以订单记录为准）</p>
      <p>注册电话：XXX-XXXXXXXX（示例，请以订单记录为准）</p>
      <p>开户银行：招商银行股份有限公司XXXX支行（示例，请以订单记录为准）</p>
      <p>银行账号：XXXXXXXXXXXXXXX（示例，请以订单记录为准）</p>
      <p>发票内容：服务类别（请根据实际服务和国家相关规定填写）</p>
      <p>发票类别：企业须开具增值税专用发票</p>
    </div>
    <div class="main_item">
      <p>第六条 发票验收处理</p>
      <p>神州邦邦平台在收到纸质发票后七个工作日内，对收取的发票进行认证并验收，并将已验收认证信息反馈给工程师。当发票验收成功后，工程师的提现审核将予以通过，按照平台规则进入提现流程；如发票验收未成功，请工程师按照平台反馈信息对发票内容进行修改。对于增值税专用发票纳税人识别号、名称信息出现错误，需重新开具的情况，神州邦邦平台将错票快递给工程师，需要工程师重新开具并快递给神州邦邦平台进行再次验收。</p>
      <p>对于开具虚假发票情况，神州邦邦平台将按照神州邦邦平台处罚规则，对工程师进行处罚。</p>
      <p>为保障工程师尽快提现服务费，建议您认真、及时开票、寄票！</p>
      <p>注意：发票的开具注意事项：</p>
      <ul class="content_wrap1">
        <li>
          <p>货物或应税服务名称、数量、金额等内容必须与实际发生业务保持一致。</p>
        </li>
        <li>
          <p>发票每一栏的金额、税额加计数应与合计栏金额、税额相等。</p>
        </li>
        <li>
          <p>收款人、复核人、开票人必须填写真实、完整的姓名，且复核人名字不能与收款人或开票人一样。</p>
        </li>
        <li>
          <p>纸质发票代码和发票号码必须与发票右上端由税控系统打印的发票代码和发票号码保持一致。</p>
        </li>
        <li>
          <p>发票打印的信息应保持字迹清楚、不得压线、错格、出格等。</p>
        </li>
        <li>
          <p>增值税发票必须在发票联和抵扣联加盖发票专用章。</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>